export default function IllegalChars() {
    return {
        scope: {
            stringOfIllegalChars: "=",
        },
        require: "ngModel",
        link: function (scope, elem, attrs, ctrl) {
            const illegalChars = /[A-zàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßŁłØøÅåÆæœ0-9$&+,:;=?@#|'<>.^*()%!-]/gm;

            elem.on("keyup", function () {
                scope.$apply(function () {
                    scope.stringOfIllegalChars = elem
                        .val()
                        .replace(illegalChars, "");

                    var valid = true;
                    if (scope.stringOfIllegalChars.length > 0) {
                        valid = false;
                    }

                    ctrl.$setValidity("illegalChars", valid);
                });
            });
        },
    };
}
